module.exports = __webpack_public_path__ + "img/TomMcGee.d61c11a6.jpg";